import TwilioTasks from "@/views/console/TwilioTasks";
import C from "@/utils/constants";

export default [
  {
    path: "twilio-tasks",
    component: TwilioTasks,
    meta: {
      roles: [C.ROLE.ADMIN, C.ROLE.AGENT_ENGAGEMENT],
    },
    children: [
      {
        path: "",
        name: "twilio-tasks",
        component: () =>
          import("@/components/console/twilio-tasks/TwilioTaskList"),
        meta: {
          roles: [
            C.ROLE.ADMIN,
            C.ROLE.AGENT_ENGAGEMENT,
            C.ROLE.BROKERAGE_ADMIN,
            C.ROLE.CSR_VIEW_OPPORTUNITIES,
          ],
        },
      },
    ],
  },
];
